(() => {
  angular
    .module('gm.common.services')
    .factory('gmRecurringPayments', gmRecurringPayments);

  function gmRecurringPayments(
    $q,
    gmApi,
    GmyVaults
  ) {
    'ngInject';

    function attachVaultAndCardInfo(vaults, cards = null) {
      return (payment) => {
        payment.vault = vaults.find(vault => vault.id === payment.params.value.vaultId);

        if (payment.params.type === 'RedemptionParams' && cards) {
          payment.card = cards.find(c => c.san === payment.params.value.payload.value.san);
        }

        return payment;
      };
    }

    function getRecurringPayments() {
      return gmApi
        .get('recurring-payments')
        .then(payments => payments.filter(_ => _.params.type !== 'PayrollParams'));
    }

    return {
      getPayments(ppCards = null) {
        return $q.all([getRecurringPayments(), GmyVaults.getVaults()])
          .then(([payments, vaults]) => payments.map(attachVaultAndCardInfo(vaults, ppCards)))
          .then((recurringTx) => {
            const notDepositsTypes = [
              'SendPaymentParams',
              'RedemptionParams',
              'RequestPaymentParams'
            ];

            const ppcLoads = recurringTx.filter(tx => tx.params.type === 'RedemptionParams');
            const payments = recurringTx.filter(tx => tx.params.type === 'SendPaymentParams');
            const requests = recurringTx.filter(tx => tx.params.type === 'RequestPaymentParams');

            const deposits = recurringTx
              .filter(tx => notDepositsTypes.indexOf(tx.params.type) === -1);

            return { payments, deposits, requests, ppcLoads };
          });
      },

      getCardRecurringPayment(card, payments) {
        return payments.find(p => p.card && p.card.san === card.san);
      },

      updatePayment(payment) {
        const payload = {
          period: payment.period,
          userAmount: payment.params.value.userAmount
        };

        if (payment.vault) {
          payload.vaultId = payment.vault.id;
        }

        return gmApi.put(`recurring-payments/${payment.id}`, payload, { auth: true });
      },

      suspendPayment(payment) {
        return gmApi.put(`recurring-payments/${payment.id}/suspended`, {}, { auth: true });
      },

      resumePayment(payment, twoFactAuth) {
        return gmApi.delete(
          `recurring-payments/${payment.id}/suspended`,
          { twoFactAuth, auth: true }
        );
      },

      deletePayment(payment) {
        return gmApi.delete(`recurring-payments/${payment.id}`, { auth: true });
      },

      deletePaymentById(id) {
        return gmApi.delete(`recurring-payments/${id}`, { auth: true });
      }
    };
  }
})();
